// eslint-disable-next-line unicorn/filename-case
import React, { useContext, useCallback } from 'react';
import _ from 'lodash';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { withRouter } from 'react-router-dom';
import { useModal } from '@jutro/components';

import metadata from './ELInformationComponent.metadata.json5';
import styles from '../../EnvImpairment/envImpairment.module.scss'
import messages from './ELInformationComponent.messages';
import LiabilityExposureComponent from '../LiabilityExposures/LiabilityExposuresComponent';
import StorageTankInfoComponent from '../StorageTankInfo/StorageTankInfoComponent';
import CoveredLocationsComponent from '../CoveredLocations/CoveredLocationsComponent';
import CoveredLocationsDetailsComponent from '../CoveredLocationsDetails/CoveredLocationsDetailsComponent';
import { useTranslator } from '@jutro/locale';
import { BreakpointTrackerContext } from '@jutro/legacy/layout';

function ELInformationComponent(props) {

    const { submissionVM, updateWizardData, pathUpdated, index, viewModelService } = props;
    const breakpoint = useContext(BreakpointTrackerContext);
    const { onValidate } = useValidation('ELInformationComponent');
    const modelVM = _.get(submissionVM, pathUpdated)
    const { showConfirm } = useModal();
    const locRiskPath = 'lobData.envLin.coverables.locRisks';
    const translator = useTranslator();

    const handleValueChange = useCallback(
        (value, changedPath) => {

            _.set(submissionVM, `${pathUpdated}.${changedPath}`, value);

            updateWizardData(submissionVM);
        },
        [pathUpdated, submissionVM, updateWizardData]
    );

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const overrideProps = {
        '@field': {
            showRequired: true,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top'
        },
        LiabilityExposureComponent: {
            submissionVM,
            updateWizardData,
            pathUpdated: `${locRiskPath}.children[${index}].liabilityExposures`
        },
        StorageTankInfoComponent: {
            submissionVM,
            updateWizardData,
            pathUpdated: `${locRiskPath}.children[${index}].storageTankInformation`
        },
        CoveredLocationsComponent: {
            submissionVM,
            updateWizardData,
            pathUpdated: `${locRiskPath}.children[${index}].coveredLocations`,
            viewModelService
        },
        CoveredLocationsDetailsComponent: {
            submissionVM,
            updateWizardData,
            pathUpdated: `${locRiskPath}.children[${index}].coveredLocationsDetails`
        },
        InformationAccordionDetails: {
            title: `${translator(messages.coveredLocation)} ${index + 1}`
        }
    };


    const deletelocRisk = useCallback(
        () => {
            const infoListPath = `${locRiskPath}.value`;
            const info = modelVM.value;
            const infoList = _.get(submissionVM, infoListPath);

            showConfirm({
                title: messages.removeInfo,
                message: messages.removeInfoDesc,
                status: 'warning',
                icon: 'mi-error-outline',
                confirmButtonText: messages.yes,
                cancelButtonText: messages.no
            }).then(
                (results) => {
                    if (results === 'cancel') {
                        return _.noop();
                    }

                    const newinfoList = _.remove(infoList,
                        (infoFromList) => _.isEqual(infoFromList, info));

                    _.set(submissionVM, newinfoList, infoListPath);
                    updateWizardData(submissionVM);

                    return true;
                }, _.noop
            );
        }, [modelVM.value, submissionVM, showConfirm, updateWizardData]
    );


    const resolvers = {
        resolveCallbackMap: {
            deletelocRisk
        },
        resolveComponentMap: {
            LiabilityExposureComponent,
            StorageTankInfoComponent,
            CoveredLocationsComponent,
            CoveredLocationsDetailsComponent
        },
        resolveClassNameMap: styles
    };

    const readValue = useCallback(
        (id, path) => readViewModelValue(metadata.componentContent, _.get(submissionVM, pathUpdated), id, path, overrideProps),
        [overrideProps, pathUpdated, submissionVM]
    );

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={modelVM}
            resolveValue={readValue}
            overrideProps={overrideProps}
            onValidationChange={onValidate}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );


}

ELInformationComponent.propTypes = wizardProps;
export default withRouter(ELInformationComponent);
